module.exports = __webpack_public_path__ + "static/media/projects-text-cs.05e4d924.svg";